import React from "react";
import './delete-item-btn.scss'

const DeleteItemBtn = ({onClick, btnText, disabled}) => (
    <button className={`item-delete-button ${disabled ? "disabled" : ""}`} onClick={onClick}>
        <img src={`${process.env.PUBLIC_URL}/images/delete-btn.svg`} alt="delete"/>
        {btnText ? <span className={"item-delete-button__text"}>{btnText}</span> : null}
    </button>
)

export default DeleteItemBtn;